const ElasticFormParagraph: React.FC<ParagraphHTML> = ({ content }) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </>
  );
};

export default ElasticFormParagraph;
